import React, { Component } from "react";
import { connect } from "react-redux";

import axios from "axios";

import { getApartmentInsuranceName } from "../reducers/apartmentAction";
import { setAdditionalInsuranceFromApi, setAttachmentsFromApi, setTextSelection, setHouseCompany } from '../reducers/simpleAction'
import { bindActionCreators } from "redux";

class PriceInformationCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      error: false,
      extraInformations: [],
      extraInformationCount: 0,
      attachments: [],
      attachmentsCount: 0,
      priceQuotes: [],
      priceQuotesCount: 0,
      additionalInsurance: [],
      additionalInsuranceCount: 0,
      timeUnit: "år"
    };
  }

  componentDidMount() {
    const company = this.props.housingCompanyPath;
    const url = process.env.LF_API_URL + "/homeinsurance/prices/" + company;
      
    axios
      .get(url)
      .then(data => {
        this.setState({
          priceQuotes: data.data.rates.priceQuotes,
          priceQuotesCount: data.data.rates.priceQuotes.length,
          attachments: data.data.rates.attachments,
          attachmentsCount: data.data.rates.attachments.length,
          extraInformations: data.data.rates.extraInformations,
          extraInformationCount: data.data.rates.extraInformations.length,
          additionalInsurance: data.data.rates.additionalInsuranceQuotes,
          additionalInsuranceCount: data.data.rates.additionalInsuranceQuotes.length,
          error: false,
          timeUnit: data.data.rates.additionalInsuranceQuotes[0].timeUnit.replace("/", "")
        });
        
        this.props.setAdditionalInsuranceFromApi(data.data.rates.additionalInsuranceQuotes);
        this.props.setAttachmentsFromApi(data.data.rates.attachments);
        this.props.setTextSelection(data.data.textSections);
      })
      .catch(err => {
        this.setState({
          errorMessage: "Vi kan tyvärr inte hämta priserna just nu. Testa igen eller kontakta kundtjänst.",
          error: true
        });
      });
  }

  render() {
    let priceSectionOne = "";
    let priceTitleOne = "";
    let showPriceOne = false;

    let priceSectionTwo = "";
    let priceTitleTwo = "";
    let showPriceTwo = false;

    let priceSectionThree = "";
    let priceTitleThree = "";
    let showPriceThree = false;

    let additionalInsurance = "";

    let extraInformationTitle = this.state.extraInformationCount > 1 ? "Pris* per " + this.state.timeUnit + " för fullvärdesförsäkring**" : "Pris per " + this.state.timeUnit + " för fullvärdesförsäkring*";

    const extraInformation = this.state.extraInformations.map((el, key) => {
      return (
        <div key={key}>
          <p><small>{el.body}</small></p>
        </div>
      );
    });

    const priceQuotesAreaOne = this.state.priceQuotes.map((quote, key) => {
      if (quote.quoteArea == 1 || quote.quoteArea == null || quote.quoteArea == "1B") {
        priceTitleOne = quote.quoteAreaText;
        showPriceOne = true;
        return (
          <div className="row" key={key}>
            <div className="col-3">
              <p className="text-sm">{quote.rooms} {(quote.rooms > 4) ? "+ rum" : " rum"}</p>
            </div>
            <div className="col text-right">
              <small>{quote.formatPriceUnder65.replace(".", " ")}</small>
            </div>
            <div className="col text-right">
              <small>{quote.formatPriceOver64.replace(".", " ")}</small>
            </div>
          </div>
        );
      }
    });

    const priceQuotesAreaTwo = this.state.priceQuotes.map((quote, key) => {
      if (quote.quoteArea == 2) {
        priceTitleTwo = quote.quoteAreaText;
        showPriceTwo = true;
        return (
          <div className="row" key={key}>
            <div className="col-3">
              <p className="text-sm">{quote.rooms} {(quote.rooms > 4) ? "+ rum" : " rum"}</p>
            </div>
            <div className="col text-right">
              <small>{quote.formatPriceUnder65.replace(".", " ")}</small>
            </div>
            <div className="col text-right">
              <small>{quote.formatPriceOver64.replace(".", " ")}</small>
            </div>
          </div>
        );
      }
    });

    const priceQuotesAreaThree = this.state.priceQuotes.map((quote, key) => {
      if (quote.quoteArea == 3) {
        priceTitleThree = quote.quoteAreaText;
        showPriceThree = true;
        
        return (
          <div className="row" key={key}>
            <div className="col-3">
              <p className="text-sm">{quote.rooms} {(quote.rooms > 4) ? "+ rum" : " rum"}</p>
            </div>
            <div className="col text-right">
              <small>{quote.formatPriceUnder65.replace(".", " ")}</small>
            </div>
            <div className="col text-right">
              <small>{quote.formatPriceOver64.replace(".", " ")}</small>
            </div>
          </div>
        );
      }
    });

    if(showPriceOne) {
      priceSectionOne = <div>
        <p>{priceTitleOne}</p>
        <div className="">
          <h6>{extraInformationTitle}</h6>
          <div className="row bb-2">
            <div className="col-3"></div>
            <div className="col"><h5>Tom 64 år</h5></div>
            <div className="col"><h5>From 65 år</h5></div>
          </div>
          {priceQuotesAreaOne}
          <hr className="on-white-bg" />
          <br />
        </div>
      </div>
    };

    if(showPriceTwo) {
      priceSectionTwo = <div>
        <p>{priceTitleTwo}</p>
        <div className="">
          <h6>{extraInformationTitle}</h6>
          <div className="row bb-2">
          <div className="col-3"></div>
            <div className="col"><h5>Tom 64 år</h5></div>
            <div className="col"><h5>From 65 år</h5></div>
          </div>
          {priceQuotesAreaTwo}
          <hr className="on-white-bg" />
          <br />
        </div>
      </div>;
    }
    
    if(showPriceThree) {
      priceSectionThree = <div>
        <p>{priceTitleThree}</p>
        <div className="">
          <h6>{extraInformationTitle}</h6>
          <div className="row bb-2">
            <div className="col-3"></div>
            <div className="col"><h5>Tom 64 år</h5></div>
            <div className="col"><h5>From 65 år</h5></div>
          </div>
          {priceQuotesAreaThree}
          <hr className="on-white-bg" />
          <br />
        </div>
      </div>;
    }

    if(this.state.additionalInsuranceCount > 1) {
      const insurances =  this.state.additionalInsurance.map((quote, key) => {
        return (
          <div className="row" key={key}>
            <div className="col">
              <p className="text-sm">{getApartmentInsuranceName(quote.additionalInsuranceType)}</p>
            </div>
            <div className="col-3">
            <p className="text-sm">{quote.price} kr</p>
            </div>
          </div>
        );
      });
      
      additionalInsurance = <div className="">
        <h5 className="bb-2">Tilläggsförsäkringar pris per {this.state.additionalInsurance[0].timeUnit.replace("/", "")}</h5>
        { insurances }
      </div>
    }

    let prices = "";
    if (!this.state.error) {
      prices = (
        <div className="card-body">
          <div className="pdf-block p-0">
            
            {priceSectionOne}
            {priceSectionTwo}
            {priceSectionThree}

            {additionalInsurance}

            {extraInformation}

          </div>
        </div>
      );
    }

    return (
      <div className="card bg-white">
        <h4 className="card-header">Priser - Gäller för 2024</h4>
        { this.state.errorMessage }
        
        { prices }

        <div className="card-body">
          <div className="pdf-block p-0">
            {this.state.attachments.map((attachment, key) =>
                <p key={key}>
                  <a target="_blank" href={getApartmentResourceURL(attachment.aHrefPath)} className="btn btn-secondary" role="button">
                    {attachment.aHrefName}
                  </a>
                </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const getApartmentResourceURL = (path) => {
  return process.env.LF_RESOURCES_URL + path;
}

const mapStateToProps = state => {
  return {
    housingCompanyPath: state.simpleReducer.housingCompanyPath,
    apartment_information: state.apartmentReducer.apartment_information,
    textSections: state.simpleReducer.textSections,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setAdditionalInsuranceFromApi: bindActionCreators(setAdditionalInsuranceFromApi, dispatch),
    setAttachmentsFromApi: bindActionCreators(setAttachmentsFromApi, dispatch),
    setTextSelection: bindActionCreators(setTextSelection, dispatch),
    setHouseCompany: bindActionCreators(setHouseCompany, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriceInformationCard);
